'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import FormText from '@/components/form/FormText/FormText';
import { swal } from '@/lib/sweetalert';
import { yup } from '@/lib/yup';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { pickErrorMessages } from '@/utils/functions';
import { yupResolver } from '@hookform/resolvers/yup';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { postForgotPassword } from '../../api/postForgotPassword';
import styles from './ForgotPasswordForm.module.scss';

const formScheme = yup.object().shape({
  email: yup.string().email().required(),
});

function ForgotPasswordForm() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);

  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(formScheme),
  });

  const submit = async () => {
    try {
      setIsLoading(true);
      await postForgotPassword({
        email: getValues('email'),
        oemServiceId: Number(process.env.NEXT_PUBLIC_SERVICE_ID),
      });
      await swal.alert({ text: 'メールを送信しました。' });
    } catch (error) {
      await swal.messages({ messages: pickErrorMessages(error) });
    } finally {
      setIsLoading(false);
    }
  };

  const submitError = async () => {
    await swal.invalid();
  };

  return (
    <div className={styles.componentStyle}>
      <div className={utilsStyles.mtMedium}>
        <div className={utilsStyles.mtSmall}>
          <p className={`${utilsStyles.textXSmall}`}>
            登録済のメールアドレスを入力し 「再発行メールを受け取る」ボタンを押すと、
            <br />
            入力したメールアドレス宛に@jump-lab.jpよりURLが記載されたメールが届きます。
            <br />
            届いたメールに記載されているURLより変更手続きを行ってください。
            <br />
            URLの有効期限は1時間です。
            <br />
            1時間以内にアクセスできなかった場合は再度送信ください。
            <br />
            @jump-lab.jpよりメールが受信できるように設定してください。
            <br />
          </p>
        </div>
      </div>
      <form className={utilsStyles.mtSmall} onSubmit={(e) => e.preventDefault()}>
        <FormText label='メールアドレス' name='email' control={control} type='email' required isPii />
        <div className={`${utilsStyles.mtMedium} ${layoutStyles.centeredBtnWrapper}`}>
          <ActionButton
            onClick={handleSubmit(submit, submitError)}
            bgColor='primary'
            color='white'
            size='large'
            isLoading={isLoading}
          >
            再発行メールを受け取る
          </ActionButton>
          <ActionButton
            onClick={() => {
              router.push('/auth/signin');
            }}
            outlined={true}
          >
            前の画面にもどる
          </ActionButton>
        </div>
      </form>
    </div>
  );
}

export default ForgotPasswordForm;
